import React, { useState } from "react";

import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker  from '@hassanmojab/react-modern-calendar-datepicker';

import "./HourlyAndDailyLeaves.scss"
import moment from 'jalali-moment'
import moments from 'moment'

import { TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import LoginInDialog from "../Login/LoginInDialog";
import Axios from "middleware/axiosInstance";

const NewHourlyLeave = () => {

    // check if authentication is expired
    const [authenticationIsExpired, setAuthenticationIsExpired] = useState(false);

    const [dayOfLeave, setDayOfLeave] = useState(null);
    const [StartTime, setStartTime] = useState(null);
    const [EndTime, setEndTime] = useState(null);
    const [leaveReason, setLeaveReason] = useState("")

    const LeaveDayAndHoursRangeSelected = dayOfLeave !== null && StartTime !== null && EndTime !== null


    // in process to disable button
    const [inProcess, setInProcess] = useState(false)
    // set start time of leave
    const handleStartDateChange = (date) => {
        setStartTime(date);
    };
    // set end time of leave
    const handleEndDateChange = (date) => {
        setEndTime(date);
    };

    // customize input start daily leave
    const CustomStartInput = ({ ref }) => (
        <input
            readOnly
            ref={ref} // necessary
            placeholder="تاریخ شروع مرخصی"
            value={dayOfLeave ? `${dayOfLeave.year}/${dayOfLeave.month}/${dayOfLeave.day}` : ''}
            style={{
                textAlign: 'center',
                padding: '0.1rem',
                fontSize: '0.9rem',
                border: '1px solid #1877F2',
                borderRadius: '3px',
                color: '#1877F2',
                outline: 'none',
                height: '30px',
                width: '150px',
                margin: '30px 5px'
            }}
            className="custom-input-start-daily-leave" // a styling class
        />
    )
    // create a random number between 20000-30000
    function CreateRandomLeaveNumber() {
        return Math.floor(Math.random() * 10000) + 20000;
    }
    const SubmitHourlyLeave = async () => {
        // check internet connection
        if (!navigator.onLine) {
            alert("به اینترنت متصل نمی باشید")
            // throw "an error"
        }
        else {
            setInProcess(true)
            try {
                const DateOfLeave = await moment.from(`${dayOfLeave.year}/${dayOfLeave.month}/${dayOfLeave.day}`, 'fa', 'YYYY/M/D').format('YYYY/MM/DD')
                const startHourlyLeave = `${DateOfLeave} ${moments(`${StartTime.toLocaleTimeString("en-us")}`, 'hh:mm A').format('HH:mm')}:00`
                const endHourlyLeave = `${DateOfLeave} ${moments(`${EndTime.toLocaleTimeString("en-us")}`, 'hh:mm A').format('HH:mm')}:00`
                const LeaveNumber = await CreateRandomLeaveNumber()
                const hourlyLeaveTemplate = {
                    "api_token": `${localStorage.getItem("token")}`,
                    "number": `${LeaveNumber}`,
                    "from": `${startHourlyLeave}`,
                    "to": `${endHourlyLeave}`,
                    "leave_reason": `${leaveReason}`
                }

                const apiURL = process.env.REACT_APP_BASE_API_URL
                const apiRoute = "leave"
                Axios.post(apiRoute, hourlyLeaveTemplate, { 'Accept': 'application/json', })
                    .then((response) => {
                        setInProcess(false)
                        alert("مرخصی شما با موفقیت ثبت شد")
                    })
                    .catch((error) => {
                        setInProcess(false)
                        error.response.data.message === "Unauthenticated." ? setAuthenticationIsExpired(true) :
                            console.error(error);
                    })
            }
            catch {
                setInProcess(false)
                alert("مشکلی پیش آمده جهت اطمینان لطفا از سامانه خارج شده و مجددا وارد شوید!")
            }
        }
    }
    return (
        <div className="main-leave-container">
            <div className="leave-inputs-container">
                <DatePicker
                    value={dayOfLeave}
                    onChange={setDayOfLeave}
                    shouldHighlightWeekends
                    // add for persian
                    locale="fa"
                    // render a custom input
                    renderInput={CustomStartInput}
                    calendarClassName="responsive-calendar"
                />
            </div>
            <div className="hourly-timepicker-container">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <TimePicker
                        clearable
                        okLabel="تأیید"
                        cancelLabel="لغو"
                        clearLabel="پاک کردن"
                        label="ساعت شروع مرخصی"
                        value={StartTime}
                        onChange={handleStartDateChange}
                        ampm={false}
                        fullWidth
                        minutesStep={15}
                        onKeyDown={(event) => {
                            event.preventDefault();
                            return false
                        }}
                    />
                    <TimePicker
                        clearable
                        okLabel="تأیید"
                        cancelLabel="لغو"
                        clearLabel="پاک کردن"
                        label="ساعت پایان مرخصی"
                        value={EndTime}
                        onChange={handleEndDateChange}
                        ampm={false}
                        fullWidth
                        minutesStep={15}
                        onKeyDown={(event) => {
                            event.preventDefault();
                            return false
                        }}
                    />
                </MuiPickersUtilsProvider>
            </div>
            <div className="leaves-reason-container">
                <div>
                    <textarea onBlur={e => setLeaveReason(e.target.value)}
                        style={{ "padding": "3px" }}
                        placeholder="در صورت تمایل می توانید توضیحات خود را در رابطه با مرخصی در این قسمت وارد نمایید!"
                        name="" id="" cols="35" rows="5" maxLength="150" />
                </div>
            </div>
            <div className="leave-button-container">
                <button onClick={SubmitHourlyLeave}
                    disabled={inProcess || !LeaveDayAndHoursRangeSelected}
                    // variant="contained"
                    // color={LeaveDayAndHoursRangeSelected ? inProcess ? `secondary` : `success` : `error`}
                    className={LeaveDayAndHoursRangeSelected ? inProcess ? `custom-button-disable` : `custom-button-green` : `custom-button-disable`}
                // className={LeaveDayAndHoursRangeSelected ?
                //     `custom-button-disable` : inProcess ? `custom-button-green` : `custom-button`}
                >
                    {StartTime === null || EndTime === null ? `ابتدا تاریخ و ساعت را مشخص فرمایید` :
                        inProcess ?
                            ` ... درحال ارسال درخواست` :
                            `ثبت مرخصی`}
                </button>
            </div>
            {authenticationIsExpired && <LoginInDialog />}
        </div>
    );
};
export default NewHourlyLeave;